export const data1 = [
  {
    id: "javascript",
    label: "javascript",
    value: 40,
    color: "hsl(111, 90%, 90%)",
  },
  {
    id: "sass",
    label: "sass",
    value: 60,
    color: "hsl(22, 90%, 90%)",
  },
];

export const data2 = [
  {
    id: "javascript",
    label: "javascript",
    value: 70,
    color: "hsl(111, 90%, 90%)",
  },
  {
    id: "sass",
    label: "sass",
    value: 30,
    color: "hsl(22, 90%, 90%)",
  },
];

export const data3 = [
  {
    id: "javascript",
    label: "javascript",
    value: 44,
    color: "hsl(111, 90%, 90%)",
  },
  {
    id: "sass",
    label: "sass",
    value: 66,
    color: "hsl(22, 90%, 90%)",
  },
];

export const data4 = [
  {
    id: "javascript",
    label: "javascript",
    value: 77,
    color: "hsl(111, 90%, 90%)",
  },
  {
    id: "sass",
    label: "sass",
    value: 33,
    color: "hsl(22, 90%, 90%)",
  },
];



export const Transactions = [
  {
    txId: "01e4dsaewf",
    user: "johndoe",
    date: "2021-09-01",
    cost: "43.91",
  },
  {
    txId: "0315dsaaef",
    user: "jackdower",
    date: "2022-04-01",
    cost: "133.45",
  },
  {
    txId: "01e4dsaef",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "51034szvfew",
    user: "goodmanave",
    date: "2022-11-05",
    cost: "200.95",
  },
  {
    txId: "0a123sb",
    user: "stevebower",
    date: "2022-11-02",
    cost: "13.55",
  },
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "120s51a",
    user: "wootzifer",
    date: "2019-04-15",
    cost: "24.20",
  },
  {
    txId: "0315dsaa",
    user: "jackdower",
    date: "2022-04-01",
    cost: "133.49",
  },
];